import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AdvertType } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import { AdvertCardListCounter } from '#advert/components/card-list';
import advertCardListCss from './assets/advert-card-list.module.scss';
import advertCardListStubCss from './assets/advert-card-list-stub.module.scss';
import { AdvertCard } from '#advert/components/card';

type PropsType = {
  adverts: AdvertType[];
  total?: number;
  isAllowBottomSheet?: boolean;
  max6?: boolean;
};

const AdvertCardList: FC<PropsType> = ({
  adverts,
  total = null,
  isAllowBottomSheet = false,
  max6 = false,
}) => {
  if (adverts.length === 0) {
    return (
      <div className={advertCardListStubCss.advertCardListStub}>
        <FormattedMessage defaultMessage="There are not models" />
      </div>
    );
  }

  const advertCardElementList = adverts.map((advert) => (
    <AdvertCard key={advert.id} advert={advert} isAllowBottomSheet={isAllowBottomSheet} />
  ));

  return (
    <>
      <AdvertCardListCounter total={total} />
      <div
        className={classNames(
          advertCardListCss.advertCardList,
          { [advertCardListCss.advertCardList_max6]: max6 },
        )}
      >
        {advertCardElementList}
      </div>
    </>
  );
};

export { AdvertCardList };
